<template>
  <section :class="$style.container" data-luko-tracking="OptionContent">
    <Wrapper :class="$style.wrapper">
      <Title :class="$style.title" :title-params="primary.title" />
      <RichText v-if="primary.description" :class="$style.description" :text-params="primary.description" />
      <RichText v-if="primary.option_description" :class="$style.option_description" :text-params="primary.option_description" />
      <OptionMenu v-if="items.length" :items="items" :selected-option="selectedOption" @onSelect="onSelect" />
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'

import OptionMenu from './components/OptionMenu'

export default {
  name: 'Options',
  components: {
    Title,
    RichText,
    OptionMenu,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
    selectedOption: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },

  methods: {
    onSelect(index) {
      this.$emit('onSelect', index)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 128px 24px 0;
}
.wrapper {
  text-align: center;
}

.title {
  @include typo-extra-title;
  padding: 0 10px;

  color: $gray-1000;
  font-weight: 200;
}

.description {
  @include typo-body;
  color: $gray-700;
}

.option_description {
  @include typo-headline;
  margin: 40px 0;

  font-weight: $gray-1000;
}
</style>
